import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createAffiliatePartner } from '../actions/affiliatepartnerActions'
import Country from '../components/Country'
import Header from '../components/Header'
import LeftComponent from '../components/LeftComponent'
import { AFFILIATE_PARTNER_CREATE_RESET } from '../constants/affiliatePartnerConstants'
import { affiliatePartnerJson } from '../models/affiliatePartnerModel'

export default function AffiliatePartnerCreateScreen() {
    const dispatch = useDispatch();

    const [parameters, setParameters] = useState(affiliatePartnerJson);

    const affiliatePartnerCreate = useSelector(state => state.affiliatePartnerCreate)
    const { loading, error, success } = affiliatePartnerCreate

    const handleValue = (e) => {
        setParameters({ ...parameters, [e.target.name]: e.target.value });
    }

    const SaveRecord = (e) => {
        dispatch(createAffiliatePartner(parameters))
        // console.log(parameters)
    }

    useEffect(() => {
        if (success) {
            setParameters(affiliatePartnerJson);
            setTimeout(() => {
                dispatch({
                    type: AFFILIATE_PARTNER_CREATE_RESET
                })
            }, 10000);
        }

    }, [dispatch, success])

    return (
        <>
            <Header pageName="Affiliate Partner" />
            <LeftComponent />
            <div className="content-body">
                <div className="container-fluid">
                    <div className="heading-title">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="home-title float-left">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="inner-body">
                        <div className="invoice-details">
                            <div className="container">
                                <div id="InvoiceAccordion" className="accordion-invoice">
                                    <div className="card mb-0">
                                        <div className="card-header collapsed" data-toggle="collapse" href="#collapseOne">
                                            <a className="card-title">
                                                Affiliate Partner Details
                                            </a>
                                        </div>

                                        <div className="card-body collapse show"  >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Affiliate Partner Name* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="affiliate partner name"
                                                                name="Affiliate_Partner"
                                                                value={parameters.Affiliate_Partner}
                                                                onChange={e => handleValue(e)} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Affiliate Partner Address* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            {/* <div className="input-group-prepend">
                                                                <span className="input-group-text">$</span>
                                                            </div> */}
                                                            <textarea className="form-control form-control-sm" placeholder="address..."
                                                                name="AffiliatePartner_Address"
                                                                value={parameters.AffiliatePartner_Address}
                                                                onChange={e => handleValue(e)}></textarea>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Country* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="Country_Id"
                                                                value={parameters.Country_Id}
                                                                onChange={e => handleValue(e)} >
                                                                <option value="">--Select--</option>
                                                                <Country />
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card-header collapsed" >
                                            <a className="card-title">
                                                Other Details
                                            </a>
                                        </div>
                                        <div className="card-body collapse show" >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" name="Contact_Person" value={parameters.Contact_Person} onChange={e => handleValue(e)} placeholder="contact person" />

                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person Email*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Contact_Email" value={parameters.Contact_Email} onChange={e => handleValue(e)} placeholder="contact person email" />

                                                        </div>
                                                    </div>

                                                   
                                                </div>

                                                <div className="col-md-6">
                                                <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person Number*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Contact_Number" value={parameters.Contact_Number} onChange={e => handleValue(e)} placeholder="contact person number" />

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>


                                        <div className="card-header collapsed"   >
                                            <a className="card-title">
                                                Commission Details
                                            </a>
                                        </div>
                                        <div id="collapseThree" className="card-body collapse  show"  >
                                            <div className="row">
                                                <div className="col-md-6">
                                                <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Percentage*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="commission percentage" name="Commision_Percentage" value={parameters.Commision_Percentage} onChange={e => handleValue(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Bonus*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="bonus" name="Bonus" value={parameters.Bonus} onChange={e => handleValue(e)} />

                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commision Including GST</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select type="text" className="form-control form-control-sm" name="Commision_Including_GST" value={parameters.Commision_Including_GST} onChange={(e) => handleValue(e)}>
                                                                <option value="">--Select--</option>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 text-center">
                                                    <hr />
                                                    <>
                                                        {
                                                            loading ? (
                                                                <div className="Create-btn">
                                                                    Loading...
                                                                </div>
                                                            ) : (
                                                                <div className="Create-btn">
                                                                    <a className="btn create-contact"
                                                                        onClick={e => SaveRecord(e)}>Save</a>
                                                                </div>
                                                            )
                                                        }
                                                    </>
                                                    <span className='text-success'>{success}</span>
                                                    <span className='text-danger'>{error}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

